import React from "react";
import { Box, Text } from "@chakra-ui/react";
import PrivateBilling from "../components/PrivateBilling";
import PublicBilling from "../components/PublicBilling";
import Configurations from "../components/Configurations";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyUAdmins } from "utils/accessLevels";

const BillingPanel = ({ id, station, refresh }) => {
  return (
    <>
      <PublicBilling id={id} station={station} refresh={refresh} />
      <PrivateBilling id={id} station={station} />
      <RoleBasedRender roles={onlyUAdmins}>
        <Box mt={5}>
          <Text fontSize="md" fontWeight="bold" color="gray.700" mb={4}>
            Payout Configurations
          </Text>
          <Configurations id={id} station={station} />
        </Box>
      </RoleBasedRender>
    </>
  );
};

export default BillingPanel;
